import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserInfo } from '@/stores/UserInfoStore';
import NavBar from '@/components/NavBar';
import RichTextEditor from '@/components/RichTextEditor';

// type HTMLTemplateProps = {
//   template: string;
//   variables: Record<string, string>;
// };

// type Variables = {
//   date: string;
//   subject: string;
//   amount: string;
//   revision: string;
//   [key: string]: string; // Allow for dynamic keys
// };

// const HTMLTemplate: React.FC<HTMLTemplateProps> = ({ template, variables }) => {
//   const [userVariables, setUserVariables] = useState<Record<string, string>>(variables);

//   // Additional static variables
//   const additionalVariables: Variables = {
//     date: new Date().toLocaleDateString(),
//     subject: 'Default Subject',
//     amount: '100.00',
//     revision: '1.0',
//   };

//   // State to manage merged variables
//   const [mergedVariables, setMergedVariables] = useState<Variables>({
//     ...additionalVariables,
//     ...userVariables,
//   });

//   // Function to replace variables in the template
//   const renderTemplate = (data: Record<string, string>) => {
//     return template.replace(/\{(.*?)\}/g, (_, key) => data[key.trim()] || '');
//   };

//   const handleInputChange = (key: string, value: string) => {
//     setUserVariables((prev) => {
//       const updatedUserVariables = { ...prev, [key]: value };
//       setMergedVariables({ ...additionalVariables, ...updatedUserVariables });
//       return updatedUserVariables;
//     });
//   };

//   const navigate = useNavigate();
//   const { userInfo, refresh } = useUserInfo();
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       await refresh();
//       setLoading(false);
//     };

//     fetchData();
//   }, []);

//   return (
//     <div className="app">
//       <div className="row">
//         <div className="col">
//           {Object.keys(mergedVariables).map((key) => (
//             <div key={key} style={{ marginBottom: '1rem' }}>
//               <label htmlFor={key} style={{ marginRight: '0.5rem' }}>{key}:</label>
//               <textarea
//                 id={key}
//                 value={userVariables[key] || ''}
//                 onChange={(e) => handleInputChange(key, e.target.value)}
//                 style={{ width: '100%', minHeight: '50px' }}
//               />
//             </div>
//           ))}
//         </div>
//         <div>
//           <h2>Content with Additional Variables:</h2>
//           <p><strong>Date:</strong> {additionalVariables.date}</p>
//           <p><strong>Subject:</strong> {additionalVariables.subject}</p>
//           <p><strong>Amount:</strong> {additionalVariables.amount}</p>
//           <p><strong>Revision:</strong> {additionalVariables.revision}</p>
//         </div>

//         <div>
//           <h2>Generated Content for Each Table Row:</h2>
//           <div dangerouslySetInnerHTML={{ __html: renderTemplate({ ...additionalVariables }) }} />
//         </div>
//       </div>
//       <NavBar />
//     </div>
//   );
// };

const HTMLTemplate: React.FC = () => {
  return (
    <div className="app">       
      <div className="row">
        
      <RichTextEditor />
      </div>
      <NavBar />
    </div>
    
  );
}

export default HTMLTemplate;
